import React from "react";

// ASSETS

import letterLipActive from "../../assets/module-5/letter-lip-active.svg";
import letterLipInactive from "../../assets/module-5/letter-lip-inactive.svg";

import starBookmarkActive from "../../assets/module-5/star-bookmark-active.svg";
import starBookmarkInactive from "../../assets/module-5/star-bookmark-inactive.svg";

import locationDot from "../../assets/module-5/location-dot.svg";
import magnifyingGlass from "../../assets/module-5/magnifying-glass.svg";
import memo from "../../assets/module-5/memo.svg";
import wrench from "../../assets/module-5/wrench.svg";

const icons = {
  pin: locationDot,
  mag: magnifyingGlass,
  memo: memo,
  wrench: wrench,
};

const LdsBlockListItem = ({
  active = true,
  number,
  iconSlug,
  title,
  bookmarked,
}) => {
  return (
    <div className={`lds-block-list-item ${active ? "active" : "inactive"}`}>
      <div className="lds-block-list-item-number">{number}</div>
      {bookmarked && (
        <img
          className="lds-block-list-item-bookmark"
          src={active ? starBookmarkActive : starBookmarkInactive}
          alt="bookmark"
        />
      )}
      <div className="lds-block-list-item-icon-area">
        <img
          className="lds-block-list-item-letter-lip"
          src={active ? letterLipActive : letterLipInactive}
          alt="icon"
        />
        <img
          className="lds-block-list-item-icon"
          src={icons[iconSlug]}
          alt="icon"
        />
      </div>
      <div className="lds-block-list-item-title">{title}</div>
    </div>
  );
};

export default LdsBlockListItem;
